// extracted by mini-css-extract-plugin
export var button = "PayPalButton-module__button___I6grA";
export var logo = "PayPalButton-module__logo___JcrJ2";
export var text = "PayPalButton-module__text___csLW4";